import React from 'react';
import FilterableDatatable from "../../components/table/filterable-data-table";
import * as api from "../../api";
import ContractsTradingPositionTableHeader from "./contracts-trading-position-table-header";
import ContractsTradingPositionTableRow from "./contracts-trading-position-table-row";
import {from} from "linq";
import ArrayDataProvider from "../../components/table/data-providers/array-data-provider";

export default class ContractTradePosition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ArrayDataProvider([]),
        };

        this.fetchData();
    }

    fetchData()
    {
        api.getContractVolumeList(this.props.customerId, this.props.contractId)
            .then(({data}) => this.transformData(data))
            .then(this.state.dataProvider.updateDataSource)
    }

    transformData(data) {
        const transformedDataset = [];

        const enumerableData = from(data);
        const periods = enumerableData
            .orderBy(x => x.periodStartDate)
            .select(x => x.periodName)
            .distinct()
            .toArray();

        periods.forEach(period => {
            const periodData = enumerableData
                .where(x => x.periodName === period);

            const baseloadData = periodData.singleOrDefault(x => x.loadTypeId === 0);
            const peakData = periodData.singleOrDefault(x => x.loadTypeId !== 0);

            const transformedData = {
                month: baseloadData ? baseloadData.periodName : peakData.periodName,
                date: baseloadData ? baseloadData.periodStartDate : peakData.periodStartDate,
                baseTotalCapacity: baseloadData ? baseloadData.totalVolume : null,
                baseTradedCapacity: baseloadData ? baseloadData.tradedCapacity : null,
                baseExposedCapacity: baseloadData ? baseloadData.exposedCapacity : null,
                baseTraded: baseloadData ? baseloadData.percentTraded : null,
                baseExposed: baseloadData ? baseloadData.percentExposed : null,
                baseTradeWA: baseloadData ? baseloadData.tradeWeightedAverage : null,
                peakTotalCapacity: peakData ? peakData.totalVolume : null,
                peakTradedCapacity: peakData ? peakData.tradedCapacity : null,
                peakExposedCapacity: peakData ? peakData.exposedCapacity : null,
                peakTraded: peakData ? peakData.percentTraded : null,
                peakExposed: peakData ? peakData.percentExposed : null,
                peakTradeWA: peakData ? peakData.tradeWeightedAverage : null
            };

            transformedDataset.push(transformedData);
        });

        return transformedDataset;
    }

    render() {
        return (
            <FilterableDatatable dataProvider={this.state.dataProvider} name="contract-trading-position" canExport={true}
                                 refreshDataTrigger={this.state.dataProvider.onDataSourceChanged}
                                 headerComponent={ContractsTradingPositionTableHeader} rowComponent={ContractsTradingPositionTableRow} />
        );
    }
}